import { createSlice } from "@reduxjs/toolkit";

export const globalVisibleSlice = createSlice({
	name: "globalVisibleSlice",
	initialState: {
		question: false,
		newsFeed: false,
		interactiveTutorial: false,
	},
	reducers: {
		setQuestionVisible: (state, { payload }) => {
			state.question = payload;
		},
		setNewsFeedVisible: (state, { payload }) => {
			state.newsFeed = payload;
		},
		setInteractiveTutorial: (state, { payload }) => {
			state.interactiveTutorial = payload;
		},
	},
});

export const { setQuestionVisible, setNewsFeedVisible, setInteractiveTutorial } = globalVisibleSlice.actions;

export default globalVisibleSlice.reducer;
